/** Request/application status badge colors (pill style: light background + colored text) */
export const STATUS_COLOR: Record<
  string,
  { text: string; background: string }
> = {
  NEW: { text: '#3C91E6', background: '#E8EFFB' },
  WAITING_ACCEPTANCE: { text: '#F58F29', background: '#FEF6F2' },
  EXPIRED: { text: '#4DA167', background: '#E8F5E9' },
  RETURNED: { text: '#3C91E6', background: '#E8EFFB' },
  CORRECTED: { text: '#3C91E6', background: '#E8EFFB' },
  APPROVED: { text: '#4DA167', background: '#E8F5E9' },
  REJECTED: { text: '#D32F2F', background: '#FFEBEE' },
  DELETED: { text: '#D32F2F', background: '#FFEBEE' },
};

export const DISPUTE_STATUS_COLOR = {
  UNDER_EXAMINATION: { text: '#F58F29', background: '#FEF6F2' },
  NEW: { text: '#3C91E6', background: '#F3F6FD' },
  FRIENDLY_STAGE: { text: '#F58F29', background: '#FEF6F2' },
  ARBITRATION_STAGE: { text: '#F58F29', background: '#FEF6F2' },
  ARBITRATED: { text: '#F58F29', background: '#FEF6F2' },
  WITHDRAW: { text: '#F58F29', background: '#FEF6F2' },
};

export const ReasonCodes = Object.freeze({
  // Shared Reasons
  POOR_COMMUNICATION: 'POOR_COMMUNICATION',
  VIOLATION_TERMS: 'VIOLATION_TERMS',
  IP_DISPUTE: 'IP_DISPUTE',
  // Client Reasons
  LOW_QUALITY: 'LOW_QUALITY',
  MISSED_REQUIREMENTS: 'MISSED_REQUIREMENTS',
  MISSED_DEADLINE: 'MISSED_DEADLINE',
  // Talent Reasons
  SCOPE_CREEP: 'SCOPE_CREEP',
  DISAGREEMENT_REVISIONS: 'DISAGREEMENT_REVISIONS',
});

// CHANGED: Decision types as enum-like object
export const DecisionTypes = Object.freeze({
  REQUEST_CR: 'REQUEST_CR',
  HOLD_SCOPE: 'HOLD_NEW_SCOPE',
  CLOSE_DISPUTE: 'CLOSE_DISPUTE',
  CONTRACT_CLOSURE: 'CONTRACT_CLOSURE',
  TIME_EXTENSION: 'TIME_EXTENSION',
  REFER_AGREEMENT: 'REFER_ORIGINAL_AGREEMENT',
  PERMANENT_SUSPENSION: 'PERMANENT_SUSPENSION',
  TEMPORARY_SUSPENSION: 'TEMPORARY_SUSPENSION',
  PROOF_OF_OWNERSHIP: 'PROOF_OWNERSHIP',
  REQUEST_FIXES: 'REQUEST_FIXES',
  DEDUCT_BUDGET: 'DEDUCT_BUDGET',
  REQUEST_CORRECTION: 'REQUEST_CORRECTION',
  DEDUCT_PAYMENT: 'DEDUCT_PAYMENT',
  DEDUCT_DAYS: 'DEDUCT_DAYS',
  FEED_BACK: 'FEED_BACK',
  PAY_EXTRA: 'PAY_EXTRA',
  RELEASE_DEDUCT_DAYS: 'RELEASE_DEDUCT_DAYS',
});

export type DecisionType = (typeof DecisionTypes)[keyof typeof DecisionTypes];

export const tempToken = `Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiI2MWJlMTRkMy03NDY4LTQ5ZDYtOGM5NC05MThiZTJjMTkzYWMiLCJzdWIiOiJhZG1pbkB5YWQuY29tIiwiaWF0IjoxNzYwODY0MjY2LCJpc3MiOiJ1c2VyLVNlcnZpY2UiLCJleHAiOjE3NjEwNDQyNjYsInJvbGVzIjpbXSwidXNlcklkIjozODkzODYsImNyZWF0ZWQiOjE3NjA4NjQyNjY3Njl9.dZh1Jm_dafZaJPzFCakwiSIIgPJZ1J0DEr9_p-1pj8pRc0Uy4cgVYf_tKXO_XUqDxoY63QYKjHiH0sUkMeANoA`;

export const QUESTION_LEVEL = {
  easy: 'EASY',
  intermediate: 'INTERMEDIATE',
  advanced: 'ADVANCED',
};

export type questionLevelType =
  (typeof QUESTION_LEVEL)[keyof typeof QUESTION_LEVEL];
export const USERS_TYPE = {
  client: 'CLIENT',
  talent: 'TALENT',
  business: 'BUSINESS',
};
export const ADMIN_ROLES = {
  superAdmin: 'SUPER_ADMIN',
  admin: 'ADMIN',
  operationMember: 'OPERATION_MEMBER',
  disputeMember: 'DISPUTE_MEMBER',
  financialMember: 'FINANCIAL_MEMBER',
  supportMember: 'SUPPORT_MEMBER',
} as const;

export const TICKET_STATUS = {
  CLOSED: 'Closed',
  NEW: 'New',
  IN_PROGRESS: 'In Progress',
} as const;

export const STATUS_STYLES = {
  CLOSED: 'bg-green-50 text-light-success',
  NEW: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-yellow-100 text-yellow-700',
  DEFAULT: 'bg-gray-100 text-gray-700',
} as const;
